// plugins/crypto.ts
export default defineNuxtPlugin(() => {
    console.log("crypto plugin");
  if (process.server) {
    console.log("server crypto");
    const crypto = require("crypto");
    global.crypto = crypto;
  }
  if (!globalThis.crypto) {
    console.log("no crypto");
    import("node:crypto").then((module) => {
      globalThis.crypto = module.webcrypto as Crypto;
    }); // import "node:crypto";

    // globalThis.crypto = webcrypto as Crypto;
  }
});
